var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.63636 10.5455C9.44727 10.5455 10.8982 9.08364 10.8982 7.27273C10.8982 5.46182 9.44727 4 7.63636 4C5.82545 4 4.36364 5.46182 4.36364 7.27273C4.36364 9.08364 5.82545 10.5455 7.63636 10.5455ZM7.63636 12.7273C5.09455 12.7273 0 14.0036 0 16.5455V19.2727H15.2727V16.5455C15.2727 14.0036 10.1782 12.7273 7.63636 12.7273Z",
    fill: "#9DB9CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3635 10.5455C18.1745 10.5455 19.6254 9.08364 19.6254 7.27273C19.6254 5.46182 18.1745 4 16.3635 4C14.5526 4 13.0908 5.46182 13.0908 7.27273C13.0908 9.08364 14.5526 10.5455 16.3635 10.5455ZM16.3635 12.7273C16.0472 12.7273 15.6872 12.7491 15.3054 12.7818C16.5708 13.6982 17.4545 14.9309 17.4545 16.5455V19.2727H23.9999V16.5455C23.9999 14.0036 18.9054 12.7273 16.3635 12.7273Z",
    fill: "#9DB9CA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.a8b415257161f14c12c922a23f190057.svg";
export { ForwardRef as ReactComponent };